import { storeBackendUrl, storeLoader, storeIsOpenNewsletterRegistration, storeNewsletterRegistrationImage, storeNewsletterRegistrationText, storeNewsletterRegistrationTitle } from './store';
import { API_URL_DEV, API_URL_PROD, NEWSLETTER_SIMPLE } from './constant';
import { redirectTo } from './router1';
import { idPageActu, idPageHome } from './router2';
import { getActus } from './api/apiActus';
import { storeActus, storeActu } from './classes/actu';
/**
 * scrollTo
 *
 * @param anchor
 */
export function scrollTo(anchor) {
    if (anchor !== "") {
        setTimeout(function () {
            const element = document.getElementById(anchor);
            element.scrollIntoView({
                block: "start",
                behavior: "smooth",
            });
        }, 300);
    }
    else {
        window.scrollTo(0, 0);
    }
}
;
/**
 * Initialisation de l'URL du backend
 */
export function setBackendUrl() {
    const base_url = window.location.origin; // URL du frontend
    const indiceLocalhost = base_url.indexOf("/127.0.0.1");
    if (indiceLocalhost > 0) {
        storeBackendUrl.set(API_URL_DEV);
    }
    else {
        storeBackendUrl.set(API_URL_PROD);
    }
}
/**
 * Mise à jour d'un cookie
 * @param name
 * @param value
 * @param hours
 */
export function setCookie(name, value, hours) {
    var expires = "";
    if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
/**
 * Récupération de la valeur d'un cookie
 * @param name
 * @returns
 */
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
/**
 * Suppression d'un cookie
 * @param name
 */
export function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
/**
 * redirection
 */
export function redirection() {
    const url = new URL(window.location.href);
    const splitUrl = url.href.split("/");
    let page = "";
    if (splitUrl.length > 3 && splitUrl[3].length > 0) {
        const splitPage = splitUrl[3].split("?");
        page = splitPage[0];
        const urlParams = new URLSearchParams(window.location.search);
        const params = updateStoreFromUrl(page, urlParams);
        redirectTo(page, params);
    }
    else {
        // Redirection simple 
        // https://www.info-ptce.fr/?redirection=toto
        const redirection_url = url.searchParams.get("redirection");
        if (redirection_url != undefined && redirection_url != "") {
            setTimeout(() => { redirectTo(redirection_url); }, 1000);
        }
        // Redirection actu
        // https://www.info-ptce/?actu={id}
        const actu_url = url.searchParams.get("actu");
        if (actu_url != undefined && actu_url != "") {
            const returnValue = getActus();
            storeActus.subscribe(actus => {
                const filteredActus = actus.filter((actu) => actu.id == parseInt(actu_url))[0];
                if (filteredActus != undefined && filteredActus != "") {
                    storeActu.set(filteredActus);
                    redirectTo(idPageActu);
                }
            });
        }
    }
}
function updateStoreFromUrl(page, urlParams) {
    let paramUrl = "";
    if (page == idPageActu) {
        const actuId = urlParams.get("id");
        if (actuId != undefined && actuId != "") {
            paramUrl = "?id=" + actuId;
            const returnValue = getActus();
            storeActus.subscribe(actus => {
                const filteredActus = actus.filter((actu) => actu.id == parseInt(actuId))[0];
                if (filteredActus != undefined && filteredActus != "") {
                    storeActu.set(filteredActus);
                }
            });
        }
    }
    else if (page == idPageHome) {
        const isNL = urlParams.get("nl");
        if (isNL != undefined && isNL != "" && isNL == "true") {
            paramUrl = "";
            storeNewsletterRegistrationTitle.set("inscription&nbsp;à&nbsp;la&nbsp;newsletter");
            storeNewsletterRegistrationText.set("");
            storeIsOpenNewsletterRegistration.set(true);
            storeNewsletterRegistrationImage.set(NEWSLETTER_SIMPLE);
        }
    }
    return paramUrl;
}
/**
 * launchLoader
 * @param tempo by default 10 seconds
 */
export function launchLoader(tempo = 10000) {
    storeLoader.set(true);
    setTimeout(function () { storeLoader.set(false); }, tempo);
}
/**
 * stopLoader
 */
export function stopLoader() {
    storeLoader.set(false);
}
